import Vue from 'vue'
import Login from '@/components/LoginModal.vue'

const LoginBox = Vue.extend(Login)

LoginBox.showLogin = (options) => {
  if (options === undefined || options === null) {
    options = { modalShow: true }
  } else {
    options = options;
  }
  let instance = new LoginBox({
    data: options
  }).$mount()
  Vue.nextTick(() => {
    instance.modalShow = true
  })
}
export { LoginBox }


// WEBPACK FOOTER //
// ./src/components/loginCom.js